class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 500);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    }
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer){
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop){
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = element => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl) ?
        FacetFiltersForm.renderSectionFromCache(filterDataUrl, event) :
        FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then(response => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
  
    // イベント発生元の要素を特定
    const sourceFilter = event ? event.target.closest('.js-filter') : null;
    const sourceForm = event ? event.target.closest('form').id : null;
  
    if (sourceForm === 'FacetFiltersForm') {
      // デスクトップでの操作の場合
      const desktopFilters = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
      desktopFilters.forEach((element) => {
        const target = document.querySelector('#FacetFiltersForm .js-filter[data-index="' + element.dataset.index + '"]');
        if (target && (!sourceFilter || target.dataset.index !== sourceFilter.dataset.index)) {
          target.innerHTML = element.innerHTML;
        }
      });
  
      // モバイル側も同期的に更新
      const mobileFilters = parsedHTML.querySelectorAll('#FacetFiltersFormMobile .js-filter');
      mobileFilters.forEach((element) => {
        const target = document.querySelector('#FacetFiltersFormMobile .js-filter[data-index="' + element.dataset.index + '"]');
        if (target) {
          target.querySelector('ul').innerHTML = element.querySelector('ul').innerHTML;
        }
      });
    } else if (sourceForm === 'FacetFiltersFormMobile') {
      // モバイルでの操作の場合
      const mobileFilters = parsedHTML.querySelectorAll('#FacetFiltersFormMobile .js-filter');
      mobileFilters.forEach((element) => {
        const target = document.querySelector('#FacetFiltersFormMobile .js-filter[data-index="' + element.dataset.index + '"]');
        if (target && (!sourceFilter || target.dataset.index !== sourceFilter.dataset.index)) {
          target.querySelector('ul').innerHTML = element.querySelector('ul').innerHTML;
        }
      });
  
      // デスクトップ側も同期的に更新
      const desktopFilters = parsedHTML.querySelectorAll('#FacetFiltersForm .js-filter');
      desktopFilters.forEach((element) => {
        const target = document.querySelector('#FacetFiltersForm .js-filter[data-index="' + element.dataset.index + '"]');
        if (target) {
          target.innerHTML = element.innerHTML;
        }
      });
    }
  
    // アクティブファセットとその他の要素の更新
    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);
  }
  
  onSubmitHandler(event) {
    event.preventDefault();
    
    // チェックボックスのクリック時
    if (event.target.type === 'checkbox') {
      const form = event.target.closest('form');
      const searchParams = this.createSearchParams(form);
      this.onSubmitForm(searchParams, event);
      return;
    }
    
    // その他のフォーム送信時
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    const forms = [];
    const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';
  
    sortFilterForms.forEach((form) => {
      if (!isMobile) {
        if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
          forms.push(this.createSearchParams(form));
        }
      } else if (form.id === 'FacetFiltersFormMobile') {
        forms.push(this.createSearchParams(form));
      }
    });
    
    this.onSubmitForm(forms.join('&'), event);
  }
  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    })

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetElement = target.querySelector('.facets__selected');
    const sourceElement = source.querySelector('.facets__selected');

    const targetElementAccessibility = target.querySelector('.facets__summary');
    const sourceElementAccessibility = source.querySelector('.facets__summary');

    if (sourceElement && targetElement) {
      target.querySelector('.facets__selected').outerHTML = source.querySelector('.facets__selected').outerHTML;
    }

    if (targetElementAccessibility && sourceElementAccessibility) {
      target.querySelector('.facets__summary').outerHTML = source.querySelector('.facets__summary').outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      }
    ]
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    
    // チェックボックスの状態を確認しながらパラメータを収集
    const paramPairs = Array.from(formData.entries()).filter(([key, value]) => {
      // チェックボックスの場合
      const input = form.querySelector(`input[name="${key}"][value="${value}"]`);
      if (input && input.type === 'checkbox') {
        // チェックされている場合のみtrue
        return input.checked;
      }
      // チェックボックス以外の場合は常にtrue
      return true;
    });
    
    // 重複チェック用のセット
    const uniquePairs = new Set();
    
    // フィルタリングされたパラメータを保持する配列
    const filteredPairs = [];
    
    paramPairs.forEach(([key, value]) => {
      const pairString = `${key}=${value}`;
      if (!uniquePairs.has(pairString)) {
        uniquePairs.add(pairString);
        filteredPairs.push([key, value]);
      }
    });
    
    const searchParams = new URLSearchParams();
    filteredPairs.forEach(([key, value]) => {
      searchParams.append(key, value);
    });
    
    return searchParams.toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'))
      this.onSubmitForm(searchParams, event)
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event)
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input')
      .forEach(element => element.addEventListener('change', this.onRangeChange.bind(this)));
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('min', 0);
    if (maxInput.value === '') minInput.setAttribute('max', maxInput.getAttribute('max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('min'));
    const max = Number(input.getAttribute('max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    
    // クリアオール用のリンクかどうかを判定
    const isClearAll = this.classList.contains('mobile-facets__clear-wrapper');
    
    if (isClearAll) {
      facetLink.addEventListener('click', this.clearAllFilters.bind(this));
    } else {
      facetLink.addEventListener('click', this.closeFilter.bind(this));
    }
    
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') {
        if (isClearAll) {
          this.clearAllFilters(event);
        } else {
          this.closeFilter(event);
        }
      }
    });
  }

  clearAllFilters(event) {
    event.preventDefault();
    
    // 全てのチェックボックスを未選択に
    const form = this.closest('form');
    if (form) {
      const checkboxes = form.querySelectorAll('input[type="checkbox"]');
      checkboxes.forEach(checkbox => {
        checkbox.checked = false;
      });
      
      // 価格範囲をリセット
      const priceInputs = form.querySelectorAll('price-range input');
      priceInputs.forEach(input => {
        input.value = '';
      });
      
      // フォームをサブミット
      const formElement = this.closest('facet-filters-form');
      if (formElement) {
        const searchParams = formElement.createSearchParams(form);
        formElement.onSubmitForm(searchParams, event);
      }
    }
    
    // モバイルメニューを閉じる
    const drawer = this.closest('menu-drawer');
    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

class FacetCustomSelector extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const selector = this.querySelector('.custom-selector');
    if (!selector) return;

    const header = selector.querySelector('.header');
    const headerText = selector.querySelector('.header-text');
    const options = selector.querySelector('.options');
    const arrow = selector.querySelector('.arrow');
    const inputId = selector.dataset.input;

    // フォーム内の特定のhidden inputを取得
    const form = this.closest('form');
    const hiddenInput = form ? form.querySelector(`#${inputId}`) : null;

    // URLパラメータからsort_byの値を取得
    const urlParams = new URLSearchParams(window.location.search);
    const sortByParam = urlParams.get('sort_by');

    if (sortByParam) {
      // data-selected="true"の要素を探す
      const selectedOption = options.querySelector('.option[data-selected="true"]');
      if (selectedOption) {
        headerText.textContent = selectedOption.textContent;
        if (hiddenInput) {
          hiddenInput.value = selectedOption.dataset.value;
        }
      }
    }
    // sort_byパラメータがない場合は、既存のhidden inputの値を使用
    else if (hiddenInput && hiddenInput.value) {
      const currentOption = options.querySelector(`[data-value="${hiddenInput.value}"]`);
      if (currentOption) {
        headerText.textContent = currentOption.textContent;
      }
    }    

    


    if (!hiddenInput) {
      console.error(`Hidden input with id ${inputId} not found in form`);
      return;
    }

    if (header) {
      header.addEventListener('click', (e) => {
        e.stopPropagation();
        
        // 他のセレクターを閉じる
        document.querySelectorAll('.custom-selector .options.open').forEach(openOptions => {
          if (openOptions !== options) {
            openOptions.classList.remove('open');
            openOptions.parentElement.querySelector('.arrow')?.classList.remove('up');
            openOptions.parentElement.querySelector('.header')?.classList.remove('open');
          }
        });

        options.classList.toggle('open');
        header.classList.toggle('open');
        arrow.classList.toggle('up');
      });
    }

    if (options) {
      options.querySelectorAll('.option').forEach(option => {
        option.addEventListener('click', (e) => {
          e.stopPropagation();
          const selectedValue = option.dataset.value;
          
          // hidden inputの値を更新
          hiddenInput.value = selectedValue;
          
          // 表示を更新
          headerText.textContent = option.textContent;
          options.classList.remove('open');
          header.classList.remove('open');
          arrow.classList.remove('up');

          // イベントをディスパッチしてフォーム送信をトリガー
          const changeEvent = new Event('change', { bubbles: true });
          hiddenInput.dispatchEvent(changeEvent);
          
          if (form) {
            const formElement = this.closest('facet-filters-form');
            if (formElement) {
              // 既存のURLパラメータを保持
              const currentParams = new URLSearchParams(window.location.search);
              const formParams = new URLSearchParams(formElement.createSearchParams(form));

              // フォームのパラメータを既存のパラメータにマージ
              formParams.forEach((value, key) => {
                currentParams.set(key, value);
              });
              
              // マージしたパラメータでフォーム送信
              formElement.onSubmitForm(currentParams.toString(), e);
            }
          }
        });
      });
    }
  }
}

customElements.define('facet-custom-selector', FacetCustomSelector);

// 外部クリックイベント
document.addEventListener('click', function(e) {
  if (!e.target.closest('.custom-selector')) {
    document.querySelectorAll('.custom-selector .options.open').forEach(options => {
      options.classList.remove('open');
      options.parentElement.querySelector('.arrow')?.classList.remove('up');
      options.parentElement.querySelector('.header')?.classList.remove('open');
    });
  }
});